angular.module('zc.projects')

.directive 'zcDescriptionConfirm', ($filter, BaseProjectConfirm) ->
  confirm = new BaseProjectConfirm $filter('translate')('projectsSettings.other.descriptionConfirm.itemDescription'), ['og_description', 'description']
  confirm.createDirective confirm.requestRecentHistories



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/other/description_confirm.directive.coffee